// Small accessible on/off switch (iOS-style). No new dependency — a styled
// button with role="switch". Used by the lawyer privacy toggles; generic
// enough to reuse elsewhere.
//
// `sm` (opt-in, Lawyers Rebuild V2): exact artboard sizing from 1i/1j —
// 38×22 track, 18px knob at 2px inset, knob shadow 0 1px 2px rgba(0,0,0,.2).
// Default sizing is unchanged for existing call sites.
const Toggle = ({ checked, onChange, disabled = false, id, label, sm = false }) => (
  <button
    type="button"
    role="switch"
    id={id}
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => !disabled && onChange(!checked)}
    className={`relative inline-flex flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#2283FF]/40 ${
      sm ? "h-[22px] w-[38px]" : "h-6 w-11"
    } ${checked ? "bg-[#2283FF]" : "bg-[#D5DBE7]"} ${
      disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
    }`}
  >
    <span
      className={`inline-block transform rounded-full bg-white transition-transform ${
        sm
          ? `h-[18px] w-[18px] shadow-[0_1px_2px_rgba(0,0,0,0.2)] ${
              checked ? "translate-x-[18px]" : "translate-x-[2px]"
            }`
          : `h-5 w-5 shadow ${checked ? "translate-x-5" : "translate-x-0.5"}`
      }`}
    />
  </button>
);

export default Toggle;
